import { render, staticRenderFns } from "./IconExternal.vue?vue&type=template&id=438b6bd1&"
import script from "./IconExternal.vue?vue&type=script&lang=ts&"
export * from "./IconExternal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports